"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemoAccordion = void 0;
const core_1 = require("@beautiful-eyes/core");
const demo_accordion_template_be_1 = __importDefault(require("./demo-accordion.template.be"));
let DemoAccordion = (() => {
    let _classDecorators = [(0, core_1.Component)({
            selector: 'DemoAccordion',
            useTemplate: demo_accordion_template_be_1.default,
            useStyleSheets: []
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = core_1.ReactiveClass;
    let _faqs_decorators;
    let _faqs_initializers = [];
    let _faqs_extraInitializers = [];
    var DemoAccordion = _classThis = class extends _classSuper {
        trackById(faq) {
            return faq.id;
        }
        toggle(id) {
            const faq = this.faqs.find(f => f.id === id);
            if (faq)
                faq.open = !faq.open;
        }
        constructor() {
            super(...arguments);
            this.faqs = __runInitializers(this, _faqs_initializers, [
                { id: 1, q: 'Is there a virtual DOM?', a: 'No -- each binding patches the real DOM directly.', open: true },
                { id: 2, q: 'How does @State track mutations?', a: 'Objects, arrays, Maps and Sets are wrapped in a Proxy; primitives use a plain accessor.', open: false },
                { id: 3, q: 'Can components nest?', a: 'Yes, arbitrarily deep, each with its own isolated set of bindings.', open: false },
            ]);
            __runInitializers(this, _faqs_extraInitializers);
        }
    };
    __setFunctionName(_classThis, "DemoAccordion");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _faqs_decorators = [(0, core_1.State)()];
        __esDecorate(null, null, _faqs_decorators, { kind: "field", name: "faqs", static: false, private: false, access: { has: obj => "faqs" in obj, get: obj => obj.faqs, set: (obj, value) => { obj.faqs = value; } }, metadata: _metadata }, _faqs_initializers, _faqs_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        DemoAccordion = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return DemoAccordion = _classThis;
})();
exports.DemoAccordion = DemoAccordion;
